import { Burger, Group } from "@mantine/core";
import { FC } from "react";
import { NotificationBell } from "./components/NotificationBell/NotificationBell";
import { UserMenu } from "./components/UserMenu";
import classes from "./Header.module.css";

interface HeaderProps {
  isOpen: boolean;
  isDisableButton: boolean;
  trigger: () => void;
}

const Header: FC<HeaderProps> = ({ isOpen, isDisableButton, trigger }) => {
  return (
    <Group
      className={classes["header"]}
      align="center"
      justify="space-between"
      wrap="nowrap"
    >
      <Group gap="sm" align="center">
        <Burger
          opened={!isOpen}
          onClick={trigger}
          size="sm"
          color="black"
          disabled={isDisableButton}
        />
      </Group>

      <Group gap="sm" align="center">
        <NotificationBell />
        <UserMenu />
      </Group>
    </Group>
  );
};

export default Header;
